import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import ReceivedSelectMain from '../../../../form/fields/ReceivedSelectMain'
import { editSupplyBillIsNakladnaAPI } from '../../../../../api/supply/supplyBillAPI'
import { setSupplyBill } from '../../../../../store/supplyBillSlice'

const ChangeNakladnaForm = ({ supplyBillBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillBd ? 
            {
                isNakladna: supplyBillBd.isNakladna,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillIsNakladnaAPI(dataForBd).then(data => {
            if (data) {
                dispatch(setSupplyBill(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillBd.id,
            isNakladna: data.isNakladna,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        <div>
            Чи отримана накладна по цьому рахунку?
        </div>
        {
			formDataProductIsField('isNakladna', 'supplyOrderItem') ?
				<ReceivedSelectMain
					required={formDataProductRequiredField('isNakladna', 'supplyOrderItem')}
					setValidate={e => updateValidate(setValid, 'isNakladna', e)}
					setValueForm={e => setValueForm(setData, 'isNakladna', e)}
					forciblyValue={data && data.isNakladna ? data.isNakladna : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeNakladnaForm